// extracted by css-extract-rspack-plugin
export default {"root":"Content_root__o7EEg"};